import { GQLCategories, GQLOffers, GQLUrls } from "@gql/types/gql";

import {
    addNoFollowToLinks,
    addStyleClassToIframe,
    addStyleClassToTable,
    resolveURL,
    titleDecoder,
    updateAnchorHref,
} from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";
import { Session } from "pages/api/session";

export default function Info({ vendor }: { vendor: GQLOffers }) {
    const { data: categoryId } = useQuery<number>(["categoryId"]);
    const { data: category } = useQuery<GQLCategories>([
        "categoryById",
        categoryId?.toString(),
    ]);
    const { data: session } = useQuery<Session>(["session"]);
    return (
        <section className="offerContainer mt-12" itemProp="description">
            <div
                dangerouslySetInnerHTML={{
                    __html: addStyleClassToTable(
                        addStyleClassToIframe(
                            addNoFollowToLinks(
                                titleDecoder(
                                    updateAnchorHref(
                                        vendor?.body as string,
                                        resolveURL(vendor.url as GQLUrls),
                                    ),
                                    {
                                        category: category?.name as string,
                                        region: session?.visitDetails?.region,
                                    },
                                ),
                            ),
                        ),
                    ),
                }}
            />
        </section>
    );
}
